import React from "react";

export const Indent = ({ amount = 1, children }) => (
	<p style={{ marginLeft: `${amount}em` }}>{children}</p>
);
